import { type ReactNode, createContext, useContext } from 'react';

export enum AccessLevel {
  Internal = 'internal',
  Alpha = 'alpha',
  Beta = 'beta',
  Public = 'public',
}

// It should be possible to compute these string variants but TypeScript is making it hard
export type AccessLevelProp = AccessLevel | 'internal' | 'alpha' | 'beta' | 'public';

export function isAccessLevelVisible(accessLevel: AccessLevelProp) {
  return accessLevel !== AccessLevel.Public;
}

const UserAccessLevelContext = createContext<AccessLevelProp | undefined | null>(undefined);

export const UserAccessLevelContextProvider = UserAccessLevelContext.Provider;

export function useAccessLevelContext(
  controlledValue?: AccessLevelProp | null,
): AccessLevelProp | undefined | null {
  const contextValue = useContext(UserAccessLevelContext);
  if (controlledValue === undefined) {
    return contextValue;
  }
  return controlledValue;
}

export function ClearAccessLevelContext({ children }: { children: ReactNode }) {
  return (
    <UserAccessLevelContextProvider value={AccessLevel.Public}>
      {children}
    </UserAccessLevelContextProvider>
  );
}
